import {type ShufflePlayerData, type ShuffleQueueData} from '../../../../shared/shuffle_queue/ShuffleInterfaces.ts'
import {ArrayUtils} from '@colonist/utils'
import {ClientUserState} from '../ClientUserState.ts'

type ShuffleQueueChangeListener = (queueData: ShuffleQueueData | undefined, playerData: ShufflePlayerData | undefined) => void

const SHUFFLE_INIT_TIMEOUT_MS = 2000

export class ClientShuffleQueueController {
    private static _shuffleQueueData: ShuffleQueueData | undefined
    private static _shufflePlayerData: ShufflePlayerData | undefined
    private static readonly changeListeners: ShuffleQueueChangeListener[] = []

    static get shuffleQueueData(): ShuffleQueueData | undefined {
        return this._shuffleQueueData
    }

    static get shufflePlayerData(): ShufflePlayerData | undefined {
        return this._shufflePlayerData
    }

    private static notifyListeners() {
        for(const changeListener of this.changeListeners) {
            changeListener(this._shuffleQueueData, this._shufflePlayerData)
        }
    }

    static updateQueueData(queueData: ShuffleQueueData) {
        this._shuffleQueueData = queueData
        this.notifyListeners()
    }

    static updatePlayerData(playerData: ShufflePlayerData) {
        this._shufflePlayerData = playerData
        this.notifyListeners()
    }

    static registerChangeListener(callback: ShuffleQueueChangeListener): () => void {
        this.changeListeners.push(callback)
        callback(this._shuffleQueueData, this._shufflePlayerData)

        return () => {
            ArrayUtils.removeElementFromArray(this.changeListeners, callback)
        }
    }

    static waitForShuffleQueueData(): Promise<ShuffleQueueData | undefined> {
        if(this._shuffleQueueData != undefined && this._shufflePlayerData != undefined) return Promise.resolve(this._shuffleQueueData)
        if(!ClientUserState.userState?.isLoggedIn) return Promise.resolve(this._shuffleQueueData)

        return new Promise((resolve) => {
            const timeout = setTimeout(() => {
                unregister()
                resolve(undefined)
            }, SHUFFLE_INIT_TIMEOUT_MS)

            const unregister = this.registerChangeListener((queueData, playerData) => {
                if(queueData == undefined) return
                if(playerData == undefined) return

                clearTimeout(timeout)
                unregister()
                resolve(queueData)
            })
        })
    }
}

